import classcat from "classcat";
import { TFunction } from "i18next";
import React from "react";

import { ButtonLink, IconRefresh } from "@touchtech/web-baselayer-ui";

import { ROUTES } from "@is/constants";

import css from "./ErrorPage.module.css";
import useManageErrorPage from "./hooks/useManageErrorPage";

type Props = {
  t: TFunction;
  noReload?: boolean;
  url?: string;
};

const ErrorPage = ({ t, url = ROUTES.EntryView, noReload = false }: Props) => {
  const { styles } = useManageErrorPage();

  return (
    <div className={css.container} style={styles}>
      <h1 className={classcat([css.title, "text-headline-4xl"])}>
        {t("Sorry, something went wrong")}
      </h1>
      <span className={classcat([css.subtitle, "text-label-2xl"])}>
        {t("Please reload the page to continue.")}
      </span>
      {!noReload && (
        <ButtonLink
          sizing="lg"
          width="full"
          renderContainer={(props) => <a href={url} {...props} />}
          className={css.buttonContainer}
        >
          <IconRefresh
            className={classcat([css.reloadIcon, "text-label-2xl"])}
          />
          <div className={css.reload}>{t("Reload")}</div>
        </ButtonLink>
      )}
    </div>
  );
};
export default ErrorPage;
